// extracted by mini-css-extract-plugin
export default {"formInput":"FormInput_formInput__Fm2pO","error":"FormInput_error__zV6gc","select":"FormInput_select__M8tj1"};